class stringExtensionsClass {
    
    // This method formats a string by replacing placeholders with provided arguments.
    public stringFormat(str: string, ...args: string[]) {
        return str.replace(/{(\d+)}/g, (match, index) => args[index] || '');
    }

    // This method checks if two strings are equal, ignoring case and accents.
    public stringEquals(str1: string, str2: string): boolean {
        return !!(str1 && str1 !== null && (str1.localeCompare(str2, undefined, { sensitivity: 'accent' }) === 0));
    }

    // This method capitalizes the first letter of a string and converts the rest to lowercase.
    public capitalize(str: string): string {
        if (str) {
            const lower = str.toLocaleLowerCase();
            return str.charAt(0).toUpperCase() + lower.slice(1);
        }
        return str;
    }

    // This method generates a GUID (Globally Unique Identifier).
    public getGUID(): string {
        var uuidValue: string = "", k: number, randomValue: number;
        for (k = 0; k < 32; k++) {
            randomValue = Math.random() * 16 | 0;

            if (k === 8 || k === 12 || k === 16 || k === 20) {
                uuidValue += "-"
            }
            uuidValue += (k === 12 ? 4 : (k === 16 ? (randomValue & (3 | 8)) : randomValue)).toString(16);
        }
        return uuidValue;
    }

    // This method returns the next letter in the alphabet based on the given index.
    public getNextAlphabet(index: number, capital: boolean = true) {
        return String.fromCharCode(index + (capital ? 65 : 97));
    }
}

export const stringExtensions = new stringExtensionsClass();